export default __webpack_public_path__ + "static/media/excel-download.86886385.svg";